import { render } from "./patients-list.vue?vue&type=template&id=81c938a0&scoped=true"
import script from "./patients-list.vue?vue&type=script&lang=js"
export * from "./patients-list.vue?vue&type=script&lang=js"

import "./patients-list.vue?vue&type=style&index=0&id=81c938a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c938a0"]])

export default __exports__